module.exports = __webpack_public_path__ + "img/hy7.3ca323aa.png";